import { render, staticRenderFns } from "./JsonPolisher.vue?vue&type=template&id=73125afe&"
import script from "./JsonPolisher.vue?vue&type=script&lang=ts&"
export * from "./JsonPolisher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports